import { fireTrackingEvent } from '../../utils/fire-tracking-event.js';

const PRODUCT_OPTIONS_ATTRIBUTE_SELECTED_EVENT_NAME = "Attribute Selected";
const trackAttributeSelected = (data) => {
    fireTrackingEvent(PRODUCT_OPTIONS_ATTRIBUTE_SELECTED_EVENT_NAME, data);
};

export { PRODUCT_OPTIONS_ATTRIBUTE_SELECTED_EVENT_NAME, trackAttributeSelected };
//# sourceMappingURL=track-attribute-selected.js.map
